module.exports = __webpack_public_path__ + "static/img/img_b.3437c0d3.png";